import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Sun, Moon } from 'lucide-react';
import Footer from '../FlexiOssLanding/Footer';
import FloatingAIRobot from './FloatingAIRobot';
import { useTheme } from '../../contexts/ThemeContext';

const ACCENTS = { Dent: '#E91E8C', Vet: '#4CAF50' };

const SubpageLayout = ({ children, productName }) => {
  const { theme, toggleTheme } = useTheme();
  const accent = ACCENTS[productName] || '#3b82f6';
  return (
    <div className="min-h-screen bg-slate-950" style={{ '--accent': accent }}>
      <header className="sticky top-0 z-50 bg-slate-900/95 backdrop-blur-xl border-b border-slate-800/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[color:var(--accent)] transition-opacity hover:opacity-75 font-bold text-sm" data-testid="back-to-home">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
          <div className="flex items-center gap-2 sm:gap-3">
            <button onClick={toggleTheme} data-testid="theme-toggle" aria-label="Toggle light or dark theme" className="p-2 rounded-lg text-slate-300 hover:text-[color:var(--accent)] hover:bg-white/5 transition-colors">
              {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            </button>
            <div className="w-8 h-8 rounded-lg bg-white/95 p-1">
              <img src="/fmsi-icon.png" alt="FMSi — Fortschritt Medical Supplies Inc." className="w-full h-full object-contain" />
            </div>
            {productName && (
              <span className="font-bold text-white text-sm hidden sm:inline">
                FlexiOss<sup className="text-[9px]">®</sup> {productName}
              </span>
            )}
          </div>
        </div>
      </header>
      <main data-readable-root>{children}</main>
      <Footer />
      <FloatingAIRobot />
    </div>
  );
};

export default SubpageLayout;
